import React, {useState} from 'react'
import "./Subscribe.css"
import { Container } from 'react-bootstrap'
import email from "../../../../assets/images/home/email.svg"
import { useTranslation } from '../../../../contexts/TranslationContext';
import { Modal, Button } from 'react-bootstrap';
import Cookies from 'js-cookie';




const Subscribe = ({ pageData,url }) => {
    const { t } = useTranslation();
    const Lang = Cookies.get("preferred_language");
    

    const subscribeData = pageData?.templates?.find(template => template.section === "Subscribe");
    const { subscribe_text, subscribe_button, subscribe_button_link} = subscribeData?.data;

    const [emailValue, setEmailValue] = useState('')
  const [loading, setLoading] = useState(false)
  const [modalMessage, setModalMessage] = useState('')
  const [modalTitle, setModalTitle] = useState('')
  const [showModal, setShowModal] = useState(false)


    
    const handleInputChange = (e) => {
      setEmailValue(e.target.value)
    }

 const handleSubscribe = async () => {
    if (!emailValue || !emailValue.includes('@')) {
      setModalTitle(t("InvalidEmail"))
      setModalMessage(t("EmailValidation"))
      setShowModal(true)
      return
    }

    setLoading(true)

    try {
      const response = await fetch(
        `${url}/api/method/alltimes.alltimes_travel.doctype.subscribers.subscribers.subscribe?email=${emailValue}`
      )
      const result = await response.json()

      if (response.status === 200) {
        setModalTitle( t("ThankYou"))
        setModalMessage(t("SuccessfulSubscribtionMessage"))
        setEmailValue('')
      } else {
        setModalTitle(t("SubscriptionFailed"))
        setModalMessage(result.message || t("ThankYou"))
      }

    } catch (error) {
      setModalTitle(t("Error"))
      setModalMessage(t("anErrorOccurred"))
    } finally {
      setShowModal(true)
      setLoading(false)
    }
  }


  return (
    <Container className="margin-top subscribe-container">
      <div className="subscribe">
        <div
          className="subscribe-title"
          dangerouslySetInnerHTML={{ __html: subscribe_text }}
        ></div>
        <div className="subscribe-inputs">
          <div style={{ position: "relative" }}>
            <input
              type="email"
              className="subscribe-input"
              placeholder={t("YourEmail")}
              value={emailValue}
              onChange={handleInputChange}
            />
            {!emailValue && (
              <img src={email} className="subscribe-input-image" alt='subscribe' />
            )}
          </div>

          <button
            onClick={handleSubscribe}
            className="subscribe-btn"
            disabled={loading}
          >
            {loading ? "Subscribing..." : subscribe_button}
          </button>
        </div>
      </div>

      <Modal show={showModal} onHide={() => setShowModal(false)} centered className="subscribe-modal"
        dir={Lang === "ar" ? "rtl" : "ltr"}>
        <Modal.Header >
          <Modal.Title>{modalTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{modalMessage}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() =>  setShowModal(false)}>
           {t("Close")}
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
}

export default Subscribe